import { memo, useState } from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import UploadButton from 'components/UploadButton';
import { BASE_URL } from 'utils/constants';
import { showErrorMessage } from 'redux/slices/notification';
import { useDispatch } from 'react-redux';

const ImageUpload = ({
  control,
  trigger,
  setValue,
  name,
  label,
  error,
  placeholder,
  setImagePath,
  setImageSrc,
}) => {
  const [progress, setProgress] = useState(0);
  const dispatch = useDispatch();

  const handleDeleteFile = () => {
    setProgress(0);
    setImageSrc(null);
    setImagePath(null);
    setValue(name, null);
  };

  const handleSelectFile = async (_file) => {
    const imageUrl = URL.createObjectURL(_file);
    setProgress(0);
    setImageSrc(null);
    setImagePath(null);

    setValue(name, _file, { shouldValidate: true });
    await trigger(name);

    if (error) return;

    const response = await Vapor.store(_file, {
      baseURL: BASE_URL,
      options: {
        withCredentials: true,
      },
      progress: (progress) => {
        setProgress(Math.round(progress * 100));
      },
    });

    if (!!response.key) {
      setImagePath(response.key);
      setImageSrc(imageUrl);
    } else {
      dispatch(showErrorMessage('Image upload failed'));

      setValue(name, null);
      setProgress(0);
      setImageSrc(null);
      setImagePath(null);
    }
  };

  return (
    <Controller
      control={control}
      name={name}
      render={() => (
        <UploadButton
          label={<div className="flex flex-row items-center">{label}</div>}
          name={name}
          onSelectFile={handleSelectFile}
          onDeleteFile={handleDeleteFile}
          error={error}
          placeholder={placeholder}
          progress={progress}
        />
      )}
    />
  );
};

export default memo(ImageUpload);

ImageUpload.defaultProps = {
  control: {},
  trigger: () => {},
  setValue: () => {},
  name: '',
  label: '',
  error: '',
  placeholder: '',
  setImagePath: () => {},
  setImageSrc: () => {},
};

ImageUpload.propTypes = {
  control: PropTypes.shape({}),
  trigger: PropTypes.func,
  setValue: PropTypes.func,
  name: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  setImagePath: PropTypes.func,
  setImageSrc: PropTypes.func,
};
